export default "__VITE_ASSET__DfTx9O46__"